import React from 'react';
import { useTheme } from '../../../contexts/ThemeContext';
import { cn } from '../../../lib/utils';
import { chipToneStyles, type ChipTone } from '../theme';

interface HealthQuickChipProps {
  label: string;
  value: string;
  tone?: ChipTone;
}

const HealthQuickChip: React.FC<HealthQuickChipProps> = ({ label, value, tone = 'neutral' }) => {
  const { colors } = useTheme();
  const style = chipToneStyles[tone];

  return (
    <div className={cn('rounded-xl border px-3 py-2 min-w-[120px]', style.shell)}>
      <p className={cn('text-[10px] uppercase tracking-wider font-semibold', colors.textMuted)}>{label}</p>
      <p className={cn('text-sm font-semibold mt-0.5 truncate', style.value)}>{value}</p>
    </div>
  );
};

export default HealthQuickChip;
